import { ThemeWrapper } from "@verity/components";
import styles from "./InterviewResultsTable.module.css";
import { Skeleton, Stack } from "@mui/material";

export default function ResultsTableSkeleton() {
	return (
		<ThemeWrapper scoped={false}>
			<div className={styles.page}>
				<div className={styles.text}>
					<Skeleton height="32px" width="162px" />
					<Skeleton height="20px" />
				</div>

				<Stack gap="10px">
					{Array.from({ length: 10 }).map((_, idx) => (
						<Skeleton key={idx} variant="rectangular" height="91px" />
					))}
				</Stack>
			</div>
		</ThemeWrapper>
	);
}
